// extracted by mini-css-extract-plugin
module.exports = {"Leads__Table":"Leads_Leads__Table__1uGiV","Leads__Pointer":"Leads_Leads__Pointer__3XiPZ"};